import React from 'react';
import { Layout } from 'antd';
import moment from 'moment';

const Footer = () => {
  return (
    <Layout.Footer style={{paddingTop: '8px', paddingBottom: '8px'}}>
      &copy; {moment().year()} Credera Enterprises Company, LLC. All rights reserved.
    </Layout.Footer>
  );
};

export { Footer };